<template>
    <div class="rt-table">
        <div class="rt-table-ov">
            <div class="rt-table-inner">
                <div class="title">
                    <div class="title-item"
                         v-for="(item,index) in rtProps"
                         :key="'title'+index"
                         :style="'max-width:'+item.width+';min-width:'+item.width">
                        <div :title="$t(item.title)">{{$t(item.title)}}</div>
                    </div>
                </div>
                <div class="content"
                     v-if="rtData.length">
                    <label class="content-cell"
                           v-for="(itemcell,indexcell) in rtData"
                           :key="'cell'+indexcell">
                        <div class="content-item"
                             v-for="(item,index) in rtProps"
                             :key="'content'+index"
                             :style="'max-width:'+item.width+';min-width:'+item.width">
                            <div v-if="item.type === 'radio'"
                                 style="display: flex;justify-content: center;">
                                <input type="radio"
                                       name="radioTable"
                                       :value="itemcell"
                                       v-model="checkItem" />
                            </div>
                            <div v-else>{{itemcell[item.key]||'--'}}</div>
                        </div>
                    </label>
                </div>
                <div class="content-nodata"
                     v-else
                     v-html="nodataHtml"></div>
            </div>
        </div>
        <div class="page-box">
            <Page v-if="rtData && rtData.length"
                  size="small"
                  :total="totalRows"
                  :current="pageData.current"
                  :pageSize="pageData.pageSize"
                  :pageSizeOpts="pageData.pageSizeOpts"
                  :placement="pageData.placement"
                  :showTotal="pageData.showTotal"
                  :showElevator="pageData.showElevator"
                  :showSizer="pageData.showSizer"
                  :transfer="pageData.transfer"
                  @on-change="onPageNumChange"
                  @on-page-size-change="onPageSizeChange" />
        </div>
    </div>
</template>

<script>
import API from '@/service/api.js'
export default {
    name: 'clusterPackageTable',
    props: {
        options: {
            type: Object,
            default () {
                return {}
            }
        },
        index: {
            type: Number,
            default () {
                return 0
            }
        }
    },
    data () {
        return {
            rtData: [],
            rtProps: [{
                title: '',
                key: '',
                type: 'radio',
                width: '50px'
            }, {
                title: '套餐编号',
                key: 'clusterName',
                width: '200px'
            }, {
                title: '架构',
                key: 'osArchitectureType',
                width: '90px'
            }, {
                title: '计算节点规格',
                key: 'computeFlavorRef',
                width: '120px'
            }, {
                title: '计算节点数量（台）',
                key: 'agentNum',
                width: '150px'
            }, {
                title: '登录节点规格',
                key: 'cliFlavorRef',
                width: '120px'
            }, {
                title: '登录节点数量（台）',
                key: 'cliNum',
                width: '140px'
            }, {
                title: 'VNC可视化节点规格',
                key: 'vncFlavorRef',
                width: '150px'
            }, {
                title: 'VNC可视化节点数量（台）',
                key: 'vncNum'
            }],
            pageData: {
                show: true,
                pageWays: 'server',
                current: 1,
                pageSize: 10,
                pageSizeOpts: [10, 20, 30, 40],
                placement: 'bottom',
                showTotal: true,
                showElevator: true,
                showSizer: true,
                transfer: true
            },
            totalRows: null,
            checkItem: null,
            timer: null,
            url: '',
            defaultUrl: API.GET_PRE_HPC,
            nodataHtml: '<div class="nodata-pack"><span class="nodata-msg">' + this.$t('暂无数据') + '</span></div>'
        }
    },
    watch: {
        checkItem (v) {
            this.$emit('checkItem', v, this.index)
        },
        options: {
            handler (v) {
                // const url = v.customUrl[0].url
                // if (this.timer) {
                //     clearTimeout(this.timer)
                // }
                // if (url && this.url === url) return
                // this.timer = setTimeout(() => {
                //     this.url = url
                //     this.getData()
                // }, 5 * 1000)
            },
            deep: true
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            const params = {
                pagenum: parseInt(this.pageData.current) - 1,
                pagesize: this.pageData.pageSize
            }
            this.axios.get(this.urlFormat(this.defaultUrl, false), { params }).then(res => {
                if (res) {
                    this.totalRows = res.totalRows || res.length
                    this.rtData = res.dataList || res
                }
            })
        },
        // 页码改变
        onPageNumChange (current) {
            this.pageData.current = current
            this.getData()
            // 翻页清楚页面中选中文本
            window.getSelection() ? window.getSelection().removeAllRanges() : document.selection.empty()
        },
        // 每页条数改变
        onPageSizeChange (pageSize) {
            this.pageData.pageSize = pageSize
            this.getData()
        }
    }
}
</script>
<style lang="less" scoped>
input[type='radio'] {
    width: 14px;
    height: 14px;
    vertical-align: middle;
    cursor: pointer;
}
.rt-table {
    width: 100%;
    overflow: hidden;
    .rt-table-ov {
        overflow-x: auto;
    }
    .rt-table-inner {
        min-width: max-content;
    }
}
.title {
    display: flex;
    height: 42px;
    font-weight: bold;
    font-size: 12px;
    min-width: max-content;
    color: #515a6e;
    background: #f0f2f3;
    .title-item {
        display: flex;
        align-items: center;
        flex: 1;
        padding: 0 8px;
        > div {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        &:last-child {
            max-width: none !important;
        }
    }
}
.content {
    min-width: max-content;
    .content-cell {
        display: flex;
        height: 42px;
        &:hover {
            background: #f5f6f7;
            transition: 0.2s;
        }
        .content-item {
            display: flex;
            align-items: center;
            padding: 0 8px;
            flex: 1;
            font-size: 12px;
            > div {
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            &:last-child {
                max-width: none !important;
            }
        }
    }
}
.content-nodata {
    padding: 10px 0;
}
.page-box {
    display: flex;
    justify-content: right;
    padding-top: 10px;
}
</style>
